import React, { useMemo, useEffect, useCallback, useState } from "react";
import { useHistory } from 'react-router-dom';
import { useForm, SubmitHandler } from "react-hook-form";
import { Button, Text } from "@chakra-ui/core";
import Select from "../../components/Select";
import Input from "../../components/Input";
import { useToast } from "@chakra-ui/core";
import { useFetchMotivation } from "../../service/motivationService";
import { useFetchBuilding } from "../../service/buildingService";
import { useFetchRegistration } from "../../service/registrationService";
import { IMotivation } from "../../types/IMotivation";
import { IBuilding } from "../../types/IBuilding";
import { IRegistration } from "../../types/IRegistration";
import api from '../../service/api';

import { Container, Content } from "./styles";

function compare(a: any, b: any) {
  return a.id - b.id;
}

type FormValues = {
  name: string;
  email: string;
  gpid: string;
  frequency: number;
  buildingBase: number;
  buildingReturn: number;
  motivationId: number;
  outher: string;
};

const Begin: React.FC = () => {
  const { handleSubmit, register, setValue, watch, errors, setError } = useForm<FormValues>();
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const { data: motivations } = useFetchMotivation<IMotivation[], any>();
  const { data: buildings } = useFetchBuilding<IBuilding[], any>();
  const { data: registrations } = useFetchRegistration<IRegistration[], any>();
  const gpid = watch('gpid');
  const motivationOutherSelected = watch('motivationId');
  const toast = useToast();

  const user: IRegistration | undefined = useMemo(() => {
    if (!gpid) return undefined;
    if (!registrations?.length) return undefined;
    return registrations.find((item) => item.gpid === gpid);
  }, [gpid, registrations]);

  useEffect(() => {
    if (!!user) {
      setValue('name', user.name);
      setValue('email', user.email);
    } else {
      setValue('name', "");
      setValue('email', "");
    }
  }, [user, setValue]);

  const onSubmit: SubmitHandler<FormValues> = useCallback(async (data) => {
    if (!user) {
      setError('gpid', { message: 'Gpid está inválido' });
      return;
    }

    if (user.registerWeb) {
      toast({
        position: "top-right",
        title: "Algo deu errado.",
        description: "Você já se cadastrou para o retorno voluntário",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    const { gpid, frequency, buildingBase, buildingReturn, motivationId, outher } = data;

    const dados: IRegistration = {
      name: user?.name as string,
      email: user?.email as string,
      gpid,
      frequency,
      buildingBase,
      buildingReturn,
      motivationId,
      outher
    };

    try {
      await api.post('/registration', dados);
      history.push('/concluido');

    } catch (err) {

      toast({
        position: "top-right",
        title: "Error ao realizar sua requisição.",
        description: "Confira os dados e tente novamente",
        status: "error",
        duration: 4000,
        isClosable: true,
      });

    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }

  }, [user, history, toast, setError]);

  return (
    <Container>
      <Content>
        <div className="img" />
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <Text fontSize="4xl" color="#01509C" marginBottom="-15px">
              RETORNO
            </Text>
            <Text fontSize="4xl" color="#01509C" marginBottom="20px">
              VOLUNTÁRIO
            </Text>
            <Select
              name="buildingBase"
              ref={register({ required: "Este campo é obrigatório" })}
              placeholder="Selecionar Local..."
              label="Base fixa"
              error={errors}
            >
              {buildings?.map((building) => (
                <option key={building.id} value={building.id}>
                  {building.title}
                </option>
              ))}
            </Select>
            <Select
              name="buildingReturn"
              ref={register({ required: "Este campo é obrigatório" })}
              placeholder="Selecionar Local..."
              label="Prédio que deseja retornar"
              error={errors}
            >
              {buildings
                ?.filter((building) => building.activeReserve)
                .map((building: IBuilding) => (
                  <option key={building.id} value={building.id}>
                    {building.title}
                  </option>
                ))}
            </Select>
            <Input
              placeholder="Digite GPID"
              name="gpid"
              label="GPID"
              ref={register({ required: "Este campo é obrigatório" })}
              error={errors}
            />
            <Input
              placeholder=""
              label="E-mail"
              name="email"
              ref={register()}
              isDisabled={true}
            />
            <Input
              placeholder=""
              name="name"
              label="Nome Completo"
              ref={register()}
              isDisabled={true}
            />
            <Select
              name="motivationId"
              ref={register({ required: "Este campo é obrigatório" })}
              placeholder="Selecione o motivo"
              label="Motivo pelo qual deseja retornar"
              error={errors}
            >
              {motivations?.sort(compare).map((item) => (
                <option key={item.id} value={item.id}>
                  {item.motivation}
                </option>
              ))}
            </Select>
            {motivationOutherSelected === 999 && (
              <Input
                placeholder="Motivo"
                name="outher"
                label="Seu motivo"
                ref={register()}
                error={errors}
              />
            )}
            <Select
              name="frequency"
              ref={register({ required: "Este campo é obrigatório" })}
              placeholder=""
              label="Qual a frequencia semanal?"
              error={errors}
            >
              <option value="1">1x na semana</option>
              <option value="2">2x na semana</option>
              <option value="3">3x na semana</option>
              <option value="4">4x na semana</option>
              <option value="5">5x na semana</option>
            </Select>
            <Button
              type="submit"
              variantColor="gray"
              color="#fff"
              backgroundColor="#01509C"
              _hover={{ background: '#01509C' }}
              paddingX={10}
              marginTop="20px"
              marginBottom="20px"
              isLoading={loading}
            >
              Quero retornar!
            </Button>
          </div>
        </form>
      </Content>
    </Container>
  );
};

export default Begin;
